import { render, staticRenderFns } from "./Perfumadas2024.vue?vue&type=template&id=8f80ec38&scoped=true"
import script from "./Perfumadas2024.vue?vue&type=script&lang=js"
export * from "./Perfumadas2024.vue?vue&type=script&lang=js"
import style0 from "./Perfumadas2024.vue?vue&type=style&index=0&id=8f80ec38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f80ec38",
  null
  
)

export default component.exports